import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealWonLostComponent } from './deal-won-lost/deal-won-lost.component';
import { PercentageWonLostComponent } from './percentage-won-lost/percentage-won-lost.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { NewInvoiceComponent } from './new-invoice/new-invoice.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DatatableModule as innModule } from 'inn-datatable';
import { NeglectedAccountsComponent } from './neglected-accounts/neglected-accounts.component';
import { DealLostGraphComponent } from './deal-lost-graph/deal-lost-graph.component';
import { SharedModule } from '../shared/shared.module';
import { NoActivityComponent } from './no-activity/no-activity.component';
import { DealSourceReportComponent } from './deal-source-report/deal-source-report.component';
import { NewContactReportComponent } from './new-contact-report/new-contact-report.component';
import { ProductReportComponent } from './product-report/product-report.component';
import { SubscriptionReportComponent } from './subscription-report/subscription-report.component';
import { ReportLoaderComponent } from './report-loader/report-loader.component';
import { DealForecastWonReportComponent } from './deal-forecast-won-report/deal-forecast-won-report.component';
import { TimeToWinDealComponent } from './time-to-win-deal/time-to-win-deal.component';
import { DealByAgeAmountComponent } from './deal-by-age-amount/deal-by-age-amount.component';
import { TaskReportComponent } from './task-report/task-report.component';
import { ClientEngagementComponent } from './client-engagement/client-engagement.component';
import { MarginReportComponent } from './margin-report/margin-report.component';
import { ActivityOutcomeReportComponent } from './activity-outcome-report/activity-outcome-report.component';
import { DealStageConversationComponent } from './deal-stage-conversation/deal-stage-conversation.component';
import { AvgDealDurationComponent } from './avg-deal-duration/avg-deal-duration.component';
import { DealStageDurationComponent } from './deal-stage-duration/deal-stage-duration.component';
import { MainFilterComponent } from './main-filter/main-filter.component';
import { DealPerByStageComponent } from './deal-per-by-stage/deal-per-by-stage.component';
import { DealUnchangedReportComponent } from './deal-unchanged-report/deal-unchanged-report.component';
import { NewDealReportComponent } from './new-deal-report/new-deal-report.component';
import { ReportToggleButtonComponent } from './report-toggle-button/report-toggle-button.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { YearRangeFilterComponent } from './year-range-filter/year-range-filter.component';
import { NewCardReportsComponent } from './new-card-reports/new-card-reports.component';
import { InvoicesReportComponent } from '../reports/invoices-report/invoices-report.component';
import { TopClientsComponent } from '../reports/top-clients/top-clients.component';
import { NewLeadsReportComponent } from './new-leads-report/new-leads-report.component';
import { NewCompanyReportComponent } from './new-company-report/new-company-report.component';
import { CustomDateRangeFilterComponent } from './custom-date-range-filter/custom-date-range-filter.component';

const sharedComponents = [
  NeglectedAccountsComponent,
  ProductReportComponent,
  PercentageWonLostComponent,
  DealWonLostComponent,
  NewInvoiceComponent,
  DealLostGraphComponent,
  NoActivityComponent,
  SubscriptionReportComponent,
  InvoicesReportComponent,
  TopClientsComponent,
  NewContactReportComponent,
  DealSourceReportComponent,
  ClientEngagementComponent,
  DealForecastWonReportComponent,
  TimeToWinDealComponent,
  DealByAgeAmountComponent,
  TaskReportComponent,
  NewDealReportComponent,
  DealUnchangedReportComponent,
  DealPerByStageComponent,
  ActivityOutcomeReportComponent,
  DealStageConversationComponent,
  AvgDealDurationComponent,
  MarginReportComponent,
  MainFilterComponent,
  DealStageDurationComponent,
  ReportToggleButtonComponent,
  LeaderboardComponent,
  ReportLoaderComponent,
  NewCardReportsComponent,
  NewLeadsReportComponent,
  NewCompanyReportComponent,
];
@NgModule({
  declarations: [...sharedComponents, ReportLoaderComponent, ActivityOutcomeReportComponent, YearRangeFilterComponent, NewCompanyReportComponent, CustomDateRangeFilterComponent,],
  imports: [
    SharedModule,
    CommonModule,
    innModule,
    FormsModule,
    SharedModule,
    NgApexchartsModule,
    BsDatepickerModule,
    TooltipModule.forRoot(),
  ],
  exports: [...sharedComponents]
})
export class SharedReportsModule { }
